import Rnis from '@/components/models/Rnis';
import {NullNumber} from '@/types/NullTypes';

export default class TransportV2 {

    static getRnisStatuses() {
        const out: any[] = [];
        Object.values(RnisStatusEnum).forEach((v) => {
            if (typeof v !== 'string') {
                return;
            }
            out.push({
                value: v,
                text: TransportV2.getRnisLabel(v as RnisStatusEnum),
                color: TransportV2.getRnisColor(v as RnisStatusEnum),
            });
        });
        return out;
    }

    static getRnisColor(status: RnisStatusEnum) {
        switch (status) {
            case RnisStatusEnum.InQueueForCheck:
                return 'grey';
            case RnisStatusEnum.NotRegistered:
                return 'red';
            case RnisStatusEnum.RegisteredTelemetryTransmitted:
                return 'green';
            case RnisStatusEnum.RegisteredTelemetryNotTransmitted:
                return 'orange';
            case RnisStatusEnum.RegisteredNoTerminals:
                return 'purple lighten-1';
            case RnisStatusEnum.RegisteredExpiredTelematics:
                return 'deep-orange';
            default:
                return 'grey';
        }
    }

    static getRnisLabel(status: RnisStatusEnum) {
        switch (status) {
            case RnisStatusEnum.InQueueForCheck:
                return 'В очереди на проверку';
            case RnisStatusEnum.NotRegistered:
                return 'Не зарегистрирована';
            case RnisStatusEnum.RegisteredTelemetryTransmitted:
                return 'Зарегистрирована, телематические данные передаются';
            case RnisStatusEnum.RegisteredTelemetryNotTransmitted:
                return 'Зарегистрирована, телематические данные не передаются';
            case RnisStatusEnum.RegisteredNoTerminals:
                return 'Зарегистрирована, нет терминала';
            case RnisStatusEnum.RegisteredExpiredTelematics:
                return 'Зарегистрирована, данные не передаются >24ч';
            default:
                return '';
        }
    }

    transportId: NullNumber = null;
    isEditable = 0;

    regNumber = '';
    stsNumber = '';
    vin = '';
    brand = '';
    model = '';

    proprietorName = '';

    rnisIsReg: NullNumber = null;
    rnisIsOnline: NullNumber = null;
    rnisLastMark: NullNumber = null;

    passDayStatusId = 0;
    passDayForecastDate = '';

    passDayBANumber = '';
    passDayBAStartDate = '';
    passDayBAEndDate = '';
    passDayBACancelDate = '';
    passDayBAAllowedZone = '';

    passDayBBNumber = '';
    passDayBBStartDate = '';
    passDayBBEndDate = '';
    passDayBBAllowedZone = '';

    passNightStatusId = 0;
    passNightForecastDate = '';

    passNightBANumber = '';
    passNightBAStartDate = '';
    passNightBAEndDate = '';
    passNightBACancelDate = '';
    passNightBAAllowedZone = '';

    passNightBBNumber = '';
    passNightBBStartDate = '';
    passNightBBEndDate = '';
    passNightBBAllowedZone = '';

    dcNumber = '';
    dcIssueDate = '';
    dcExpiryDate = '';
    dcOdometer = 0;
    dcOperatorNumber: NullNumber = null;
    dcOperatorStatus = '';

    updatedAt = '';
    createdAt = '';

    rnis: Rnis | null = null;

    rnisStatus: RnisStatusEnum = RnisStatusEnum.InQueueForCheck;

    constructor(init?: Partial<TransportV2>) {
        Object.assign(this, init);
    }
}


export enum RnisStatusEnum {
    InQueueForCheck = 'IN_QUEUE_FOR_CHECK',
    NotRegistered = 'NOT_REGISTERED',
    RegisteredTelemetryTransmitted = 'REGISTERED_TELEMETRY_TRANSMITTED',
    RegisteredTelemetryNotTransmitted = 'REGISTERED_TELEMETRY_NOT_TRANSMITTED',
    RegisteredNoTerminals = 'REGISTERED_NO_TERMINALS',
    RegisteredExpiredTelematics = 'REGISTERED_EXPIRED_TELEMATICS',
}

